import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ITEM_CARD_STATUS_LABEL } from '@/const'
import { ItemStatus } from '@/const/label/item'

import { CartItemErrorLabelProps } from './type'

export const CartItemErrorLabel = ({ status }: CartItemErrorLabelProps) => {
  const { t } = useTranslation()
  const itemStatusLabel = useMemo(() => {
    if (status === 'available') return ''

    // 翻訳キーが存在する場合は翻訳を使用
    if (
      ['outOfStock', 'unavailable', 'discontinued'].includes(
        status as ItemStatus
      )
    ) {
      return t(`item.status.${status}`)
    }

    // その他のステータスは定数から取得
    return ITEM_CARD_STATUS_LABEL[status as ItemStatus]
  }, [status, t])

  return (
    <>
      {itemStatusLabel && (
        <div>
          <p className={clsx('tw-text-xs tw-text-alert-500')}>
            {itemStatusLabel}
          </p>
        </div>
      )}
    </>
  )
}
